import { render, staticRenderFns } from "./CashRegisterTurnList.vue?vue&type=template&id=247225d3"
import script from "./CashRegisterTurnList.vue?vue&type=script&lang=js"
export * from "./CashRegisterTurnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports